<template>
  <b-container fluid>
    <lca-detail-header lca="생산"
                       :total="total"
                       :total-per-production="totalPerProduction"
                       :rank="rank"/>
    <b class="content-title mt-3">생산 - 에너지 (Scope 1)</b>
    <production-energy-detail :product="product"
                              :year="year"
                              class="mt-3"
                              :scope="1"
                              @totalCalculated="onEnergyTotalCalculated"/>
    <b class="content-title mt-5">생산 - 전력 (Scope 2)</b>
    <production-energy-detail :product="product"
                              :year="year"
                              class="mt-3"
                              :scope="2"
                              @totalCalculated="onElectricityTotalCalculated"/>
    <b class="content-title mt-5">생산 - 배출 (Scope 3)</b>
    <production-waste-detail :product="product"
                             :year="year"
                             class="mt-3"
                             @totalCalculated="onWasteTotalCalculated"/>
    <b class="content-title mt-5">에너지원별 온실가스 배출량 비율</b>
    <production-emission-by-energy-source :product="product"
                                          :year="year"/>
  </b-container>
</template>

<script>
import ProductionEnergyDetail from '../tables/ProductionEnergyDetail.vue'
import ProductionWasteDetail from '../tables/ProductionWasteDetail.vue'
import ProductionEmissionByEnergySource from '../charts2/ProductionEmissionByEnergySource.vue'
import LcaDetailHeader from "@/components/esg/3. Monitoring/3.2. LCA 배출량 관리/3.2.1. 제품별/LcaDetailHeader.vue";

export default {
  components: {LcaDetailHeader, ProductionWasteDetail, ProductionEnergyDetail, ProductionEmissionByEnergySource},
  props: {
    year: {
      type: Number
    },
    product: {
      type: Object,
    }
  },
  watch: {
    product: {
      immediate: true,
      deep: true,
      handler() {
        this.fetchRanks()
      }
    },
    year: {
      immediate: true,
      handler() {
        this.fetchRanks()
      }
    }
  },
  computed: {
    lca() {
      return this.$store.getters['ghg/lifeCycleStages'];
    },
    formattedRank() {
      if (!this.rank || !this.rank.rank || !this.rank.count) return null
      return `(${this.rank.rank}/${this.rank.count})`
    },
    total() {
      return this.energy.total + this.electricity.total + this.waste.total;
    },
    totalPerProduction() {
      return this.energy.totalPerProduction + this.electricity.totalPerProduction + this.waste.totalPerProduction;
    }
  },
  data() {
    return {
      rank: {rank: 0, count: 0},
      energy: {
        total: 0,
        totalPerProduction: 0
      },
      electricity: {
        total: 0,
        totalPerProduction: 0
      },
      waste: {
        total: 0,
        totalPerProduction: 0
      },
    }
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchRanks() {
      if (!this.product || !this.product.productFamilyCode || !this.product.productCode || !this.product.name) return;
      if (!this.year) return;

      try {
        this.loading = true;

        let args = [{
          years: [this.year],
          productFamilies: [this.product.productFamilyCode],
          products: [this.product.productCode],
          categories: [this.lca[2].value]
        }];

        let data = new FormData()
        data.append('path', 'esg/lca/rank/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: {Authorization: accessToken()},
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          this.rank = {rank: null, count: null}
          return
        }

        // Parse JSON data
        this.rank = JSON.parse(response.data.data)[0].data[0];
      } catch (error) {
        await this.showError(error)
      }
    },
    onEnergyTotalCalculated(total, totalPerProduction) {
      this.energy = {
        total,
        totalPerProduction
      }
    },
    onElectricityTotalCalculated(total, totalPerProduction) {
      this.electricity = {
        total,
        totalPerProduction
      }
    },
    onWasteTotalCalculated(total, totalPerProduction) {
      this.waste = {
        total,
        totalPerProduction
      }
    },
  }
}
</script>